var tSourceToGScenario = {
    'aweme_enterprise.home': 1,
    'aweme_enterprise.homepage_tab': 6,
    'aweme_enterprise.video': 7,
    'aweme_enterprise.live_card': 2,
    'aweme_enterprise.live_card_service': 10,
    'aweme_enterprise.im_message': 9,
    'aweme_enterprise.dou_plus': 25,
    'aweme_enterprise.subscription_article': 28,
};
var tSourceToGScenarioStar = {
    'star.video': 8,
};
function getGenericScenario(businessScenario, subBusinessScenario, techProvider, techImpl, interactiveMode, appId, orit) {
    if (appId === void 0) { appId = 0; }
    if (orit === void 0) { orit = ''; }
    return {
        businessScenario: businessScenario,
        subBusinessScenario: subBusinessScenario,
        techProvider: techProvider,
        techImpl: techImpl,
        interactiveMode: interactiveMode,
        appId: appId,
        orit: orit,
    };
}
function getGenericScenarioFromTrafficSource(key, gScenario) {
    if (key in tSourceToGScenario) {
        var subBusiness = tSourceToGScenario[key];
        gScenario.businessScenario = 7;
        gScenario.subBusinessScenario = subBusiness;
    }
    else if (key in tSourceToGScenarioStar) {
        gScenario.businessScenario = 14;
        gScenario.subBusinessScenario = tSourceToGScenarioStar[key];
    }
    return gScenario;
}
export var ScenarioType;
(function (ScenarioType) {
    ScenarioType[ScenarioType["store_popup"] = 1] = "store_popup";
    ScenarioType[ScenarioType["landing_page_embedded"] = 2] = "landing_page_embedded";
    ScenarioType[ScenarioType["light_landing_page"] = 3] = "light_landing_page";
    ScenarioType[ScenarioType["creative"] = 4] = "creative";
    ScenarioType[ScenarioType["slideUp"] = 5] = "slideUp";
    ScenarioType[ScenarioType["casing_mini_program"] = 6] = "casing_mini_program";
    ScenarioType[ScenarioType["landing_page_embedded_payform"] = 8] = "landing_page_embedded_payform";
    ScenarioType[ScenarioType["landing_page_slide_payform"] = 9] = "landing_page_slide_payform";
    ScenarioType[ScenarioType["light_game_page"] = 10] = "light_game_page";
    ScenarioType[ScenarioType["coupon_direct_normal"] = 12] = "coupon_direct_normal";
    ScenarioType[ScenarioType["coupon_direct_store"] = 13] = "coupon_direct_store";
    ScenarioType[ScenarioType["mini_program"] = 14] = "mini_program";
    ScenarioType[ScenarioType["playable"] = 15] = "playable";
    ScenarioType[ScenarioType["aip"] = 16] = "aip";
    ScenarioType[ScenarioType["fanqie_creative"] = 17] = "fanqie_creative";
    ScenarioType[ScenarioType["zhuxiaobang_creative"] = 18] = "zhuxiaobang_creative";
    ScenarioType[ScenarioType["xigua_creative"] = 19] = "xigua_creative";
    ScenarioType[ScenarioType["live_subscribe_one_key_form"] = 20] = "live_subscribe_one_key_form";
    ScenarioType[ScenarioType["consult_landing_page"] = 21] = "consult_landing_page";
    ScenarioType[ScenarioType["creative_live_subscribe_one_key_form"] = 22] = "creative_live_subscribe_one_key_form";
    ScenarioType[ScenarioType["pan_scenemini_program"] = 23] = "pan_scenemini_program";
    ScenarioType[ScenarioType["stay_popup"] = 24] = "stay_popup";
    ScenarioType[ScenarioType["mini_program_form_sdk"] = 25] = "mini_program_form_sdk";
    ScenarioType[ScenarioType["xiaoliu"] = 26] = "xiaoliu";
    ScenarioType[ScenarioType["enterprise_slide"] = 27] = "enterprise_slide";
    ScenarioType[ScenarioType["third_developer_h5"] = 28] = "third_developer_h5";
    ScenarioType[ScenarioType["interactive_smart"] = 29] = "interactive_smart";
})(ScenarioType || (ScenarioType = {}));
function getGenericScenarioFromOldScenario(oldScenario, techImpl) {
    var _a;
    techImpl = techImpl || 3;
    var scenarioMap = (_a = {},
        _a[ScenarioType.store_popup] = [
            2,
            0,
            2,
            techImpl,
            2,
        ],
        _a[ScenarioType.landing_page_embedded] = [
            1,
            0,
            2,
            techImpl,
            1,
        ],
        _a[ScenarioType.light_landing_page] = [
            4,
            4,
            2,
            techImpl,
            1,
        ],
        _a[ScenarioType.creative] = [
            3,
            0,
            2,
            techImpl,
            1,
        ],
        _a[ScenarioType.slideUp] = [
            1,
            0,
            2,
            techImpl,
            3,
        ],
        _a[ScenarioType.casing_mini_program] = [
            10,
            0,
            2,
            techImpl,
            1,
        ],
        _a[ScenarioType.landing_page_embedded_payform] = [
            11,
            0,
            2,
            techImpl,
            1,
        ],
        _a[ScenarioType.landing_page_slide_payform] = [
            11,
            0,
            2,
            techImpl,
            3,
        ],
        _a[ScenarioType.light_game_page] = [
            4,
            5,
            2,
            techImpl,
            1,
        ],
        _a[ScenarioType.coupon_direct_normal] = [
            1,
            11,
            2,
            techImpl,
            2,
        ],
        _a[ScenarioType.coupon_direct_store] = [
            2,
            11,
            2,
            techImpl,
            2,
        ],
        _a[ScenarioType.mini_program] = [
            18,
            0,
            14,
            4,
            1,
        ],
        _a[ScenarioType.playable] = [
            15,
            0,
            8,
            techImpl,
            2,
        ],
        _a[ScenarioType.aip] = [
            16,
            0,
            8,
            techImpl,
            1,
        ],
        _a[ScenarioType.fanqie_creative] = [
            3,
            0,
            13,
            techImpl,
            1,
        ],
        _a[ScenarioType.zhuxiaobang_creative] = [
            3,
            0,
            9,
            techImpl,
            1,
        ],
        _a[ScenarioType.xigua_creative] = [
            3,
            0,
            5,
            techImpl,
            1,
        ],
        _a[ScenarioType.live_subscribe_one_key_form] = [
            1,
            33,
            2,
            techImpl,
            1,
        ],
        _a[ScenarioType.consult_landing_page] = [
            19,
            0,
            15,
            techImpl,
            1,
        ],
        _a[ScenarioType.creative_live_subscribe_one_key_form] = [
            3,
            33,
            2,
            techImpl,
            3,
        ],
        _a[ScenarioType.pan_scenemini_program] = [
            21,
            0,
            2,
            techImpl,
            1,
        ],
        _a[ScenarioType.stay_popup] = [
            1,
            0,
            2,
            techImpl,
            4,
        ],
        _a[ScenarioType.mini_program_form_sdk] = [
            21,
            35,
            7,
            4,
            1,
        ],
        _a[ScenarioType.xiaoliu] = [
            22,
            0,
            17,
            techImpl,
            1,
        ],
        _a[ScenarioType.enterprise_slide] = [
            7,
            1,
            2,
            techImpl,
            3,
        ],
        _a[ScenarioType.third_developer_h5] = [
            24,
            35,
            8,
            3,
            1,
        ],
        _a[ScenarioType.interactive_smart] = [
            25,
            0,
            3,
            techImpl,
            3,
        ],
        _a);
    var scenario = scenarioMap[oldScenario] || scenarioMap[ScenarioType.landing_page_embedded];
    return getGenericScenario.apply(void 0, scenario);
}
function getReqIdRitFromLogExtra(log_extra) {
    try {
        var tmp = JSON.parse(log_extra || '');
        return [tmp.req_id || '', "" + (tmp.orit || tmp.rit || ''), "" + (tmp.rit || '')];
    }
    catch (e) {
        return ['', '', ''];
    }
}
function getDefaultScenario() {
    return getGenericScenario(1, 0, 2, 3, 1);
}
function getGScenarioSubmitFormat(gScenario) {
    return {
        business_scenario: gScenario.businessScenario,
        sub_business_scenario: gScenario.subBusinessScenario,
        technology_support: gScenario.techProvider,
        technology_impl: gScenario.techImpl,
        interview_mode: gScenario.interactiveMode,
        app_code: gScenario.appId,
        orit: gScenario.orit,
        tpl_env: gScenario.tplEnv,
    };
}
export function getDefaultContext() {
    return {
        req_id: '',
        cid: '',
        device_id: '',
        user_id: '',
        app_id: 0,
        app_version: '',
        rit: '',
        orit: '',
        log_extra: '',
        os: '',
        version_code: '',
        site_id: '',
        ad_id: '',
        ad_extra_data: '',
    };
}
function getConvertContext(sdk) {
    var ret = getDefaultContext();
    return sdk
        .getContext()
        .then(function (ctx) {
        ret.cid = "" + (ctx.cid || '');
        ret.device_id = "" + (ctx.device_id || '');
        ret.user_id = "" + (ctx.user_id || '');
        ret.app_id = Number(ctx.app_id) || 0;
        ret.app_version = ctx.app_version;
        ret.log_extra = ctx.log_extra;
        ret.os = ctx.os || 'android';
        var _a = getReqIdRitFromLogExtra(ctx.log_extra), req_id = _a[0], orit = _a[1], rit = _a[2];
        ret.req_id = req_id;
        ret.orit = orit;
        ret.rit = rit;
        ret.os = ctx.os;
        ret.version_code = ctx.version_code;
        ret.site_id = ctx.site_id;
        ret.ad_id = ctx.ad_id || '';
        ret.ad_extra_data = ctx.ad_extra_data || '';
        for (var key in ctx) {
            if (!(key in ret)) {
                ret[key] = ctx[key];
            }
        }
        return ret;
    })
        .catch(function () { return ret; });
}
function getMergedGScenario(gScenario, convertCtx) {
    if (!convertCtx)
        return gScenario;
    return {
        businessScenario: gScenario.businessScenario,
        subBusinessScenario: gScenario.subBusinessScenario,
        techProvider: gScenario.techProvider,
        techImpl: gScenario.techImpl,
        interactiveMode: gScenario.interactiveMode,
        appId: convertCtx.app_id,
        orit: convertCtx.orit,
        tplEnv: convertCtx.tpl_env,
    };
}
export { getGenericScenarioFromOldScenario, getReqIdRitFromLogExtra, getGenericScenario, getDefaultScenario, getGScenarioSubmitFormat, getConvertContext, getMergedGScenario, getGenericScenarioFromTrafficSource, };
